module.exports = __webpack_public_path__ + "static/media/usuario-placeholder.015abc8e.jpg";